<script setup lang="ts">
  import BulletPoint from '../tips/BulletPoint.vue';
</script>

<template>
  <div>
    <p><BulletPoint />MQ01.1.pdf</p>
    <p><BulletPoint />PR03.4.doc</p>
    <p><BulletPoint />IT15.2.txt</p>
  </div>
</template>
